import { isInvestor } from '../../../global/authentication/authentication-manager.js'
import { getRelativeBasePath } from '../../../global/environments/path.js'
import {
  getProductList,
  flattenFunds,
} from '../../../components/FundDetails/Data/FundDetailsDataSource.js'

import {
  CLOSED_END_PRODUCTS,
  ETF_PRODUCTS,
  RETAIL_PRODUCTS,
  FUTURE_SCHOLAR_529_PRODUCTS,
  VARIABLE_PRODUCTS,
} from '../../../components/FundDetails/Helpers/FundTypes.js'

const DEFAULT_CLASS = 'Institutional'

export const getProductLink = (product, path) => {
  let url = path === '/' ? '' : path
  if (url?.includes('?category') || url?.includes('assets')) {
    return `${getRelativeBasePath()}/${url}`
  } else if (url.includes('*')) {
    const _url = url.split('*')
    return `${product}/${isInvestor() ? _url[1] : _url[0]}`
  } else {
    return `${product}/${url}`
  }
}

export const productTypes = {
  MF: 'MutualFunds',
  ETF: 'ETF',
  MA: 'ManagedAccounts',
  MP: 'ModelPortfolios',
  P5: '529Plan',
  VP: 'VariableProducts',
  CEF: 'CloseEndFunds',
}

export const getAPIProductName = (name) => {
  switch (name) {
    case productTypes.MF:
      return RETAIL_PRODUCTS
    case productTypes.ETF:
      return ETF_PRODUCTS
    case productTypes.MA:
    case productTypes.MP:
      return null
    case productTypes.P5:
      return FUTURE_SCHOLAR_529_PRODUCTS
    case productTypes.VP:
      return VARIABLE_PRODUCTS
    case productTypes.CEF:
      return CLOSED_END_PRODUCTS
  }
}

export const lookupCategory = (categoryname) => {
  switch (categoryname) {
    case 'Domestic Equity':
      return { name: 'domestic-equity', order: 1 }
    case 'International Equity':
    case 'Global/International Equity':
      return { name: 'international-equity', order: 3 }
    case 'Sector Equity/Specialty':
      return { name: 'sector-equity', order: 5 }
    case 'Asset Allocation/Alternative':
    case 'Asset Allocation':
      return { name: 'asset-allocation', order: 7 }
    case 'Alternative':
      return { name: 'alternative', order: 2 }
    case 'Taxable Fixed Income':
      return { name: 'taxable-fixed-income', order: 4 }
    case 'Tax-Exempt Fixed Income':
      return { name: 'tax-exempt-fixed-income', order: 6 }
    case 'Money Market':
      return { name: 'money-market', order: 8 }
    default:
      return null
  }
}

const updateFundsWithClass = (funds, fundClass) => {
  return funds.reduce((p, fund) => {
    const _fundClass = getFundClass(fund, fundClass)
    let classes = _fundClass.fundClass || DEFAULT_CLASS
    classes = classes.includes(' ') ? classes.split(' ')[1] : classes

    return [
      ...p,
      {
        ...fund,
        cusip: _fundClass.cusip,
        fundClass: classes,
        symbol: fund.symbol || _fundClass.symbol,
      },
    ]
  }, [])
}

const getFundClass = (fund, fundClass) => {
  // Try to find the passed fund class if we can
  if (fundClass) {
    for (let i = 0; i < fund.classes.length; i++) {
      let _fundClass = fund.classes[i]

      if (_fundClass.fundClass == fundClass) {
        return _fundClass
      }
    }
  }

  // Return the first one if we can't find it
  return (fund.classes && fund.classes[0]) || {}
}

export const apiDataManipulation = async (types, productName) => {
  const data = await getProductList(productName)
  let funds,
    categories = []

  funds = flattenFunds(data).sort((a, b) =>
    a.fundName.localeCompare(b.fundName)
  )

  if (types === productTypes.MF) {
    categories = funds
      .reduce((prev, curr) => {
        if (curr.ctgName === null) {
          return prev
        }
        const categoryName = curr.ctgName
        const category = lookupCategory(categoryName)
        let group = prev.find((p) => p.url === category.name)
        if (group) {
          group.count++
        } else {
          group = {
            name: categoryName,
            url: category.name,
            order: category.order,
            count: 1,
          }
          prev.push(group)
        }
        return prev
      }, [])
      .sort((curr, prev) =>
        curr.order > prev.order ? 1 : curr.order < prev.order ? -1 : 0
      )
  }

  funds = [productTypes.ETF, productTypes.MF].includes(types)
    ? updateFundsWithClass(funds, DEFAULT_CLASS)
    : updateFundsWithClass(funds)

  if (types === productTypes.ETF) {
    funds = funds.sort((fund1, fund2) =>
      fund1.symbol.localeCompare(fund2.symbol, 'en', { sensitivity: 'base' })
    )
  }

  return {
    categories,
    funds,
  }
}
